import { render, staticRenderFns } from "./bookGoodList.vue?vue&type=template&id=016f5160&scoped=true"
import script from "./bookGoodList.vue?vue&type=script&lang=js"
export * from "./bookGoodList.vue?vue&type=script&lang=js"
import style0 from "./bookGoodList.vue?vue&type=style&index=0&id=016f5160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016f5160",
  null
  
)

export default component.exports